import { render, staticRenderFns } from "./MyBonuses.vue?vue&type=template&id=baee2efc&scoped=true"
import script from "./MyBonuses.vue?vue&type=script&lang=ts"
export * from "./MyBonuses.vue?vue&type=script&lang=ts"
import style0 from "./MyBonuses.scss?vue&type=style&index=0&id=baee2efc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baee2efc",
  null
  
)

export default component.exports